import React, { useState } from "react";

// Costanti + helper condivisi dal modulo Conti/Banca (estratti da BankSheet).
export const COUNTRIES = [
  { code: "IT", label: "Italia" },
  { code: "DE", label: "Germania (es. N26)" },
  { code: "ES", label: "Spagna" },
  { code: "FR", label: "Francia" },
  { code: "NL", label: "Paesi Bassi" },
  { code: "IE", label: "Irlanda" },
  { code: "AT", label: "Austria" },
  { code: "PT", label: "Portogallo" },
  { code: "FI", label: "Finlandia" },
  { code: "BE", label: "Belgio" },
  { code: "LT", label: "Lituania (es. Revolut)" },
];

export const fmtSync = (iso) => {
  if (!iso) return "mai";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 90) return "ora";
  if (diff < 3600) return `${Math.round(diff / 60)} min fa`;
  if (diff < 86400) return `${Math.round(diff / 3600)}h fa`;
  return `${Math.round(diff / 86400)}g fa`;
};

export const BankLogo = ({ inst, size = 8 }) => {
  const [err, setErr] = useState(false);
  const cls = size === 9 ? "h-9 w-9" : "h-8 w-8";
  if (inst.logo && !err) {
    return (
      <img
        src={inst.logo}
        alt=""
        onError={() => setErr(true)}
        className={`${cls} rounded-[6px] border border-white/[0.08] bg-white object-contain p-0.5`}
      />
    );
  }
  return (
    <span className={`mono ${cls} flex items-center justify-center rounded-[6px] border border-white/[0.08] bg-[#0D0D14] text-[11px] text-[#00FF87]`}>
      {(inst.name || "?").slice(0, 2).toUpperCase()}
    </span>
  );
};
